<div class="tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-px-8">
  <div class="tw-w-full tw-h-fit tw-bg-white tw-border tw-border-grey-600 tw-rounded-[10px] tw-py-8 tw-px-4">
    <div class="tw-w-full tw-h-fit tw-flex tw-items-center tw-gap-4 tw-mb-8">
      <p class="tw-flex-1 tw-font-poppins tw-font-bold tw-text-lg tw-text-secondary">{{ "change-password" | translate }}</p>
      <div (click)="closeModal()" class="tw-min-w-8 tw-min-h-8 tw-max-w-8 tw-max-h-8 tw-flex tw-justify-center tw-items-center tw-bg-secondary tw-rounded-full">
        <img class="tw-w-5 tw-h-5 tw-object-contain" src="../../../assets/close-icon.svg" />
      </div>
    </div>
    <div class="tw-w-full tw-h-fit">
      <form [formGroup]="changeForm">
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-mb-2">{{ "old-password" | translate }}</p>
        <div class="tw-w-full tw-h-fit tw-relative tw-flex tw-items-center tw-bg-white tw-border tw-border-grey-600 tw-mb-6 tw-rounded-[5px] tw-px-4 tw-py-3 tw-overflow-hidden">
          <input
            class="tw-w-full tw-h-full tw-font-poppins tw-font-normal tw-text-sm tw-text-secondary tw-outline-none tw-pr-8"
            [type]="inputType1"
            formControlName="old_password"
            placeholder="{{ 'enter-your-old-password' | translate }}"
          />
          <img (click)="showHideField(1)" class="tw-w-5 tw-h-5 tw-object-contain tw-absolute tw-right-4" [src]="showHide1" />
        </div>

        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-mb-2">{{ "password" | translate }}</p>
        <div class="tw-w-full tw-h-fit tw-relative tw-flex tw-items-center tw-bg-white tw-border tw-border-grey-600 tw-mb-6 tw-rounded-[5px] tw-px-4 tw-py-3 tw-overflow-hidden">
          <input
            class="tw-w-full tw-h-full tw-font-poppins tw-font-normal tw-text-sm tw-text-secondary tw-outline-none tw-pr-8"
            [type]="inputType2"
            formControlName="new_password"
            placeholder="{{ 'enter-your-password' | translate }}"
          />
          <img (click)="showHideField(2)" class="tw-w-5 tw-h-5 tw-object-contain tw-absolute tw-right-4" [src]="showHide2" />
        </div>
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-mb-2">{{ "confirm-password" | translate }}</p>
        <div class="tw-w-full tw-h-fit tw-relative tw-flex tw-items-center tw-bg-white tw-border tw-border-grey-600 tw-mb-6 tw-rounded-[5px] tw-px-4 tw-py-3 tw-overflow-hidden">
          <input
            class="tw-w-full tw-h-full tw-font-poppins tw-font-normal tw-text-sm tw-text-secondary tw-outline-none tw-pr-8"
            [type]="inputType3"
            formControlName="confirm_new_password"
            placeholder="{{ 'confirm-your-password' | translate }}"
          />
          <img (click)="showHideField(3)" class="tw-w-5 tw-h-5 tw-object-contain tw-absolute tw-right-4" [src]="showHide3" />
        </div>
        <p *ngIf="isError" class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-danger tw-mb-6">
          {{ isErrorText | translate }}
        </p>
      </form>
    </div>
    <div class="tw-w-full tw-h-2"></div>
    <button (click)="save()" class="tw-w-full tw-h-fit tw-font-poppins tw-font-bold tw-text-sm tw-text-secondary tw-bg-primary tw-rounded-[5px] tw-py-4">
      {{ "save" | translate }}
    </button>
  </div>
</div>
